import React from 'react';
import { injectIntl } from 'react-intl';
import logoBlue from '@chama/statics/assets/svg/logo-blue.svg';
import logoWhite from '@chama/statics/assets/svg/logo-white.svg';

const Logo = ({ intl: { formatMessage }, color = 'blue', ...otherProps }) => {
  let src;
  if (color === 'blue') {
    src = logoBlue;
  } else {
    src = logoWhite;
  }
  return (
    <img
      src={src}
      alt={formatMessage({
        id: 'app_title',
        defaultMessage: 'Chama Dealer Tool',
      })}
      {...otherProps}
    />
  );
};

export default injectIntl(Logo);



// WEBPACK FOOTER //
// ../ui-components/components/Logo/index.jsx